import { hasPermission } from '@/components/permission-gate/use-has-permission';
import { NavItemType } from '@/types/menu';
import { isNeighborhoodModerator, moderatorHomePath } from '@/providers/auth/neighborhood-moderation';
import type { IModeratedNeighborhood } from '@/providers/auth/types';
import menuItems from './index';

// ==============================|| PRIMA RUTĂ ACCESIBILĂ DIN MENIU (landing) ||============================== //
// Parcurge meniul lateral ÎN ORDINEA AFIȘĂRII și întoarce url-ul primului item pe care
// rolul curent îl poate accesa (aceeași logică de permisiuni ca <PermissionGate> și ca
// filtrarea din Navigation). Folosit ca landing după login, ca să nu aterizezi pe o pagină
// interzisă rolului. Sare peste iteme fără url, dezactivate sau externe (non-interne).

type PermUser =
	| { role?: string; permissions?: string[]; moderatedNeighborhood?: IModeratedNeighborhood }
	| null
	| undefined;

const FALLBACK_PATH = '/common/project';

export function getFirstAccessiblePath(
	user: PermUser,
	fallback: string = FALLBACK_PATH
): string {
	// Moderatorul de cartier are o singură pagină: cartierul lui.
	if (isNeighborhoodModerator(user)) return moderatorHomePath(user);

	const findPath = (items: NavItemType[]): string | undefined => {
		let found: string | undefined;
		items.some((item) => {
			// Fără permisiune → itemul ȘI copiii lui sunt săriți (ca la filtrarea din meniu).
			if (!hasPermission(user, item.requiredPermission, item.requiredPermissionMode)) {
				return false;
			}
			if (item.children?.length) {
				const childPath = findPath(item.children);
				if (childPath) {
					found = childPath;
					return true;
				}
			}
			if (item.url && !item.disabled && item.url.startsWith('/')) {
				found = item.url;
				return true;
			}
			return false;
		});
		return found;
	};

	return findPath(menuItems.items) ?? fallback;
}
